<template>
<div class="popup" v-show="nasShow" v-cloak>
    <div id="addNas" class="content" :class="addFtp" ref="nasDiv">
        <div class="title">
            <span>{{$t('language.popup.addCloudPopup.addNas')}}</span>
            <div class="icon white-close dialog-close" @click="nasShow=false"></div>
        </div>
        <div class="add-nas-cont">
            <div class="add-nas-cont-top">
                <div class="add-cloud-drive-position">
                    <div class="cloud NAS-add add-nas-size"></div>
                    <div class="add-cloud-text">
                        <b>{{$t('language.popup.addCloudPopup.addNas')}}</b>
                    </div>
                </div>
            </div>
            <el-tabs v-model=activeName>
                <el-tab-pane label="Via FTP" name="first">
                    <tab1 ref="viaFtp"></tab1>
                </el-tab-pane>
                <el-tab-pane label="Via WebDAV" name="second">
                    <tab2 ref="viaWebDav"></tab2>
                </el-tab-pane>
            </el-tabs>
            <button style="float:right;margin-top: 10Px;" @click.stop="addNasSubmit()">
                <span v-show="!connect">{{$t('language.common.add')}}&nbsp;&nbsp;{{cloudName}} {{$t('language.common.account')}}</span>
                <span v-show="connect">{{$t('language.common.connecting')}}<span class="cloudDotting"></span></span>
            </button>
        </div>
    </div>
</div>
</template>

<script>
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import commonstate from '@/js/constant.js';
import tab1 from "@/components/common/tabs/tabs_add_cloud/tab_via_ftp";
import tab2 from "@/components/common/tabs/tabs_add_cloud/tab_via_webDav";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            nasShow: false,
            cloudName: '',
            activeName: "first",
            addFtp: '',
            connect: false,
        }
    },
    mounted() {
        this.$refs.nasDiv.style.height = 470 + 'px';
    },
    components: {
        tab1,
        tab2
    },
    watch: {//监听切换的界面，如果是第二个界面给一个高度
        activeName(newValue, oldValue) {
            if (newValue == "second") {
                this.$refs.nasDiv.style.height = 470 + 'px';
                this.$refs.viaFtp.advancedShow = false;
            }
        }
    },
    methods: {//提交NAS请求
        addNasSubmit() {
            this.connect = true;
            let that = this;
            let addData;
            let tab1Page = this.$refs.viaFtp;
            let user = commonUtils.getUser();
            let tab2Page = this.$refs.viaWebDav;
            let redirectUrl = commonstate.addCloudRedirectUrl;
            if(this.$route.name == 'emailTransfer'){
                redirectUrl = commonstate.addFromEmailTransRedirectUrl;
            }
            if (this.activeName == 'first') {
                if (!this.$refs.viaFtp.displayName) {//如何任务名为空，则进行提示
                    that.$toast({
                        text: this.$t('language.exception.nameEmpty'),
                        type: 'fail',
                        idValue: "addNas"
                    });
                    this.connect = false;
                    return false;
                }//如果含有特殊名称，则进行提示
                if (commonstate.patternDriveName.test(this.$refs.viaFtp.displayName)) {
                    that.$toast({
                        text: that.$t('language.home.driveNameNotContain'),
                        type: 'fail',
                        idValue: "addNas"
                    });
                    this.connect = false;
                    return false;
                }//云盘名称不能大于200条
                if (this.$refs.viaFtp.displayName.length > 200) {
                    that.$toast({
                        text: 'FTP name cannot exceed 200 characters',
                        type: 'fail',
                        idValue: "addNas"
                    });
                    this.connect = false;
                    return false;
                }
                tab1Page.serverUrl = tab1Page.httpName + ':' + tab1Page.port + '?' + tab1Page.charSet + '!' + tab1Page.transferModeValue;
                addData = new addCloudUtils.addCloudData(user.id, tab1Page.displayName, tab1Page.email, tab1Page.password, null, tab1Page.serverUrl, tab1Page.optional, null, 'NAS', null, tab1Page.path, redirectUrl);
                this.Utils.doDrivesRequest("add", addData).then(res => {
                    if (res.status == 200) {
                        let drive = res.drive;
                        that.connect = false;
                        that.nasShow=false;
                        let getData=new addCloudUtils.getData(user.id,drive.id);
                        this.Utils.doDrivesRequest("get", getData).then(res1 => {
                            drive.username = res1.drive.username;
                             //把该返回的云盘数据存入缓存进行封装
                            addCloudUtils.putDriveToCategories(drive,that.ftpDialog,that);
                        });
                    } else {
                        that.connect = false;
                        if (res.reason=="unknownError" && res.msg.indexOf("real:")==0) {
                            that.$toast({
                                text: res.msg.substring(5),
                                type: 'fail',
                                idValue: "addNas"
                            });
                        } else {
                            that.$toast({
                                text: this.$t('language.exception.' + res.reason),
                                type: 'fail',
                                idValue: "addNas"
                            });
                        }
                    }

                });
            } else {
                //对输入框进行校验
                if (!tab2Page.inputCloudNameValue) {
                    that.$toast({
                        text: this.$t('language.exception.nameEmpty'),
                        type: 'fail',
                        idValue: "addNas"
                    });
                    this.connect = false;
                    return false;
                }//如果包含了特殊名进行校验
                if (commonstate.patternDriveName.test(tab2Page.inputCloudNameValue)) {
                    that.$toast({
                        text: that.$t('language.home.driveNameNotContain'),
                        type: 'fail',
                        idValue: "addNas"
                    });
                    this.connect = false;
                    return false;
                }//用户名和密码不能为空
                if (!tab2Page.username||!tab2Page.password) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addNas"
                    });
                    this.connect = false;
                    return false;
                }//如果云盘名称不能大于200条
                if (tab2Page.inputCloudNameValue.length > 200) {
                    that.$toast({
                        text: that.$t('language.home.cloudDiskName'),
                        type: 'fail',
                        idValue: "addNas"
                    });
                    this.connect = false;
                    return false;
                }
                let server;
                let index = tab2Page.webDavserverHttp.lastIndexOf("/");
                if (index && index != 7 && index != 6) {
                    let serverHttp = tab2Page.webDavserverHttp.substring(0, index);
                    let suffix = tab2Page.webDavserverHttp.substring(index, tab2Page.webDavserverHttp.length + 1)
                    if (tab2Page.path) {
                        server = serverHttp + ':' + tab2Page.portNumber + suffix + tab2Page.path;
                    } else {
                        server = serverHttp + ':' + tab2Page.portNumber + suffix;
                    }
                } else {
                    if (tab2Page.path) {
                        server = tab2Page.webDavserverHttp + ':' + tab2Page.portNumber + tab2Page.path;
                    } else {
                        server = tab2Page.webDavserverHttp + ':' + tab2Page.portNumber;
                    }
                }
                addData = new addCloudUtils.addCloudData(user.id, tab2Page.inputCloudNameValue, tab2Page.username, tab2Page.password, null, server, null, null, 'NAS', null, tab2Page.path, redirectUrl);
                //请求后端数据
                this.Utils.doDrivesRequest("add", addData).then(res => {
                    if (res.status == 201) {
                        this.Utils.openWin(res);
                        tab2Page.inputCloudNameValue = '';
                         that.connect = false;
                         that.nasShow=false;
                    } else if (res.status == 200) {
                        tab2Page.inputCloudNameValue = '';
                        that.connect = false;
                        //把该返回的云盘数据存入缓存进行封装
                        addCloudUtils.putDriveToCategories(res.drive,that.nasShow,that); 
                    } else {
                        this.connect = false;
                        if (res.reason=="unknownError" && res.msg.indexOf("real:")==0) {
                            this.$toast({
                                text: res.msg.substring(5),
                                type: 'fail',
                                idValue: "addNas"
                            });
                        } else {
                            this.$toast({
                                text: this.$t('language.exception.' + res.reason),
                                type: 'fail',
                                idValue: "addNas"
                            });
                        }
                    }
                }, err => {
                    this.connect = false;
                });

            }
        }
    }

}
</script>

<style>
#addNas {
    width: 680px;
    /*no*/
    height: 470px;
    /*no*/
}

.add-nas-cont {
    width: 640px;
    /*no*/
    padding: 0 40px 0px 20px;
    /*no*/
}

.NAS-add {
    background-position: -978Px -120Px;
}

.add-nas-size {
    width: 50px;
    /*no*/
    height: 40px;
    /*no*/
    float: left;
}

.add-nas-cont-top {
    width: 100%;
    height: 50Px;
    font-size: 16Px;
    position: relative;
}

#addNas #tab-first,
#addNas #tab-second {
    font-size: 16px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    color: #000;
}

#addNas .el-tabs__content {
    overflow: visible;
}

#addNas .el-tabs__item {
    padding: 0 10px 0 5px !important;
    color: #6f7886;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/add_nas_popup.vue